/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMoneySuspended = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M16.318 16.318a4.499 4.499 0 1 1 6.364 6.362 4.499 4.499 0 0 1-6.364-6.362zm2.269 5.508a2.499 2.499 0 0 0 3.24-3.24zm1.825-4.653a2.5 2.5 0 0 0-3.24 3.24z" />
        <path d="M13 4h5v2h-5v5h2.5a4.49 4.49 0 0 1 3.214 1.35l-1.428 1.4A2.49 2.49 0 0 0 15.5 13H13v9h-2v-2H5v-2h6v-5H8.5a4.5 4.5 0 1 1 0-9H11V2h2zM8.5 6a2.5 2.5 0 0 0 0 5H11V6z" />
      </g>
    </g>
  </Icon>
);
export { SvgMoneySuspended as MoneySuspended };
